import PropTypes from 'prop-types';
import React from 'react';

function Logo(props) {
  const { fill, ...rest } = props;
  return (
    <svg height="24" style={{ fill }} viewBox="0 0 20 24" width="20" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M0 0V14.1448L6.85287 24H14.7902L10.6319 14.1448H20V0H0Z" />
    </svg>
  );
}
Logo.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string.isRequired
};
Logo.defaultProps = {
  color: 'white'
};
export default Logo;
